<template>
  <div id="CpapStockModal" style="width: 80%;height:90%;margin-left: 10%;margin-top: 2%;">
    <div class="modal-card" style="width: 100%;height:100%;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">在庫検索</p>
      </header>
      <section class="modal-card-body">
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>保管場所コード</th>
              <td colspan="2">
                <select v-model="depositoryCode">
                  <option value=""></option>
                  <option v-for="item in depositoryCodeMaster" :key="item.depositoryCode" :value="item.depositoryCode">{{item.depositoryName}}({{item.depositoryCode}})</option>
                </select>
              </td>
              <th>機種</th>
              <td colspan="2">
                <select v-model="model">
                  <option v-for="model in modelList" :value="model.itemCode" :key="model.itemCode">{{ model.itemName }}</option>
                </select>
              </td>
              <td colspan="2"></td>
            </tr>
          </table>
          <div class="searchButton-area" style="margin-bottom:10px;text-align: center;">
            <b-button class="is-primary" @click="doSearch" :disabled="!depositoryCode">検索</b-button>
            <br/><span v-if="!depositoryCode" style="color:red; font-size:15px;">※保管場所コードを選択してください</span>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area">
          <b-table
            v-if="data.length > 0"
            id="cpapStockTable"
            :data="data"
            paginated
            per-page="20"
            pagination-position="both"
            default-sort="depositoryCode"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="depositoryCode" label="保管場所コード" width="80" centered>{{props.row.depositoryCode }}</b-table-column>
              <b-table-column field="depositoryName" label="保管場所名" width="100" centered sortable>{{props.row.depositoryName }}</b-table-column>
              <b-table-column field="itemCode" label="品目コード" width="80" centered sortable>{{props.row.itemCode}}</b-table-column>
              <b-table-column field="itemName" label="品目名" width="100" centered sortable>{{props.row.itemName}}</b-table-column>
              <b-table-column field="itemClass" label="品目分類" width="80" centered sortable>{{props.row.itemClass}}</b-table-column>
              <b-table-column field="itemClassName" label="品目分類名" width="100" centered sortable>{{props.row.itemClassName}}</b-table-column>
              <b-table-column field="quantity" label="在庫数" width="80" centered sortable>{{props.row.quantity}}</b-table-column>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "CpapStockModal",
  props: {
    targetOffice:{default:""},
    belongsId:"",
    institutionId:""
  },
  methods: {
    getDepositoryCodeMaster: function() {
      this.depositoryCodeMaster = []
      if(!this.officeCode) return
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getCpapStorageLocationPOST({
            body:{
              belongsId: _this.belongsId,
              institutionId: _this.institutionId,
              salesOfficeCode: "J"+_this.officeCode
            }
          });
        },
        async function(result){
          _this.depositoryCodeMaster = result.obj;
          var targetOffice = _this.depositoryCodeMaster.find(val => val.depositoryCode==_this.office)
          if(targetOffice){
            _this.depositoryCode = targetOffice.depositoryCode
          }
          
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    doSearch: function() {
      let _this = this;
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.internalCpap.getCpapSalesOfficeStockPOST({
            body:{
              depositoryCode: _this.depositoryCode,
              itemCode:_this.model
            }
          });
        },
        function(result) {
          // 検索結果取得
          _this.data = result.obj
        },
        function(result) {
          // エラーメッセージ表示
          _this.showErrorMessage(result);
        }
      );
    }
  },
  data() {
    var branchOfficeMaster= this.getSalesOfficeMaster();
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var modelList = []
    let deviceMaster = this.getCpapMaster();
    for(let device of deviceMaster){
      for(let item of device.items){
        modelList.push({
          itemCode:item.itemCode,
          itemName:item.itemName
        })
      }
    }
    modelList.unshift({})
    return {
      officeCode:userInfo.salesOfficeCode,
      depositoryCode:"",
      model:"",
      branchOfficeMaster,
      depositoryCodeMaster:[],
      modelList,
      data:[],
      office:this.targetOffice,
      belongsId:this.belongsId,
      institutionId:this.institutionId
    };
  },
  filters: {},
  components: {},
  mounted: function () {
    this.getDepositoryCodeMaster()
  },
};
</script>
<style lang="scss" scoped>
.customRadio {
  width:10px;
}
.result-area {
  height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/CpapStockModal.vue